import React from "react";
import AdfoxAdaptive from "./AdFoxAdaptive";

export function AdfoxBlock({ isFull, isDesktop, options, className = "adfox" }) {
    if (!options) {
        return null;
    }

    const option = isFull
        ? isDesktop
            ? options.fullPc
            : options.fullMob
        : isDesktop
        ? options.prevPc
        : options.prevMob;

    if (!option) {
        return null;
    }

    return <AdfoxAdaptive options={option} className={className} />;
}
